export default __webpack_public_path__ + "static/media/logo.9f38c246.png";